<template>
	<div class="header">Oliebollen bestellen</div>
</template>

<script>
export default {
	name: "GlobalHeader"
};
</script>
